import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Lock } from "lucide-react";
import WrapperContainer from "@components/WrapperContainer";

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.margins.medium};
  padding: ${({ theme }) => theme.margins.xl};
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
`;

const IconBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.yellow};
  color: ${({ theme }) => theme.colors.yellow};
`;

const Title = styled.h1`
  margin: 0;
  font-weight: 400;
  font-size: clamp(22px, 3vw, 40px);
  color: ${({ theme }) => theme.colors.yellow};
`;

const Message = styled.p`
  margin: 0;
  max-width: 480px;
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.gray150};
`;

const HomeLink = styled(Link)`
  margin-top: ${({ theme }) => theme.margins.small};
  padding: 8px 20px;
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.colors.yellow};
  color: ${({ theme }) => theme.colors.yellow};
  text-decoration: none;
`;

/**
 * Shown in place of a page the signed-in user is not allowed to open — by
 * role, or a manager whose configuration leaves the page's entitlement out —
 * so following a link or typing a URL says why instead of silently landing
 * on the home page.
 */
const NoPermissionPage: React.FC = () => (
  <WrapperContainer>
    <Content>
      <IconBadge>
        <Lock size={28} />
      </IconBadge>
      <Title>You don&apos;t have permission to view this page</Title>
      <Message>
        Your account doesn&apos;t have access to this section of the dashboard.
        If you think you should, ask an admin to update your permissions.
      </Message>
      <HomeLink to="/">Go to the home page</HomeLink>
    </Content>
  </WrapperContainer>
);

export default NoPermissionPage;
